// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBHe-67k6toVTerP5glULueUnSxAh62k6k",
  authDomain: "blog-notifications-61a66.firebaseapp.com",
  projectId: "blog-notifications-61a66",
  storageBucket: "blog-notifications-61a66.firebasestorage.app",
  messagingSenderId: "942515821814",
  appId: "1:942515821814:web:3db1315f29e4c0b298e0d7",
  measurementId: "G-ZKGJEMNZMF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Get API base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://infinitygames.clustersofttech.com';

export const generateToken = async (userId) => {
    const permission = await Notification.requestPermission();
  
    if (permission === "granted") {
      const token = await getToken(messaging, { vapidKey: 'BIxjb5aRlGtr92IIVjQ28h7tu6z4sbr5YFJIohRzvFk0oLov-8oBCyN97W-aPvM62HJYDOgz4qNLyJsR1dHWEAo'});
  
      await fetch(`${API_BASE_URL}/register-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, token }),
      });
  
      console.log("Token saved:", token);
    } else {
      // Permission denied → remove token
      await fetch(`${API_BASE_URL}/remove-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
    }
  };